import {useSideBarModal} from '../../../../../layout/common/useSideBarModal';
import React, {useMemo} from 'react';
import ExternalUserEnroll from '../../enroll/ExternalUserEnroll';
import {ExUserRegistrationDetails} from 'hemwb-api';

export type EnrollModalProps = {
  selectedUser?: ExUserRegistrationDetails | null;
};

export const useEnrollSideBarModal = (props?: EnrollModalProps) => {
  const {selectedUser} = props || {};
  const {buttonRef, openModal, closeModal} = useSideBarModal();

  const ModalComponent = useMemo(() => {
    return !!buttonRef && <ExternalUserEnroll selectedUser={selectedUser} onClose={closeModal} />;
  }, [buttonRef, closeModal, selectedUser]);

  return {
    openModal,
    closeModal,
    ModalComponent,
  };
};
